import { persistReducer } from "redux-persist";
import { CLINIC_TYPES } from "~/utils/constants";
import * as TYPES from "./clinicTypes";
import storage from "redux-persist/lib/storage";

const shareVariable = {
  fullName: { value: "" },
  phone: { value: "" },
  email: { value: "" },
  country_code: { value: "VIE" },
  city: { value: 0 },
  district: { value: 0 },
  ward: { value: 0 },
  address: { value: "" },
  clinicName: { value: "" },
  avatarList: [],
  clinicImageList: [],
  degreeImageList: [],
  clinicERC: { value: "" },
  clinicIntroduce: { value: "" },
  degree: { value: "" },
  subject: { value: "" },
  workPlace: { value: "" }
};

const INITIAL_STATE = {
  clinic: {},
  selectedClinic: null,
  showLoading: false,
  errorMessage: "",
  successMessage: "",
  formPhongKham: {
    ...shareVariable
  },
  formPhongMach: {
    ...shareVariable
  }
};

const clinicReducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case TYPES.CLINIC_FORM_SAVE_FIELD: {
      const { clinicType, fields } = action.payload;
      if (clinicType === CLINIC_TYPES.PM) {
        return {
          ...state,
          formPhongMach: { ...state.formPhongMach, ...fields }
        };
      } else if (clinicType === CLINIC_TYPES.PK) {
        return {
          ...state,
          formPhongKham: { ...state.formPhongKham, ...fields }
        };
      }
      break;
    }
    case TYPES.CLINIC_FORM_CREATE_FIELD_REQUEST_SUCCESS:
      return {
        ...state,
        ...INITIAL_STATE
      };
    case TYPES.RESET_CLINIC_FORM: {
      if (action.payload.clinicType === CLINIC_TYPES.PM) {
        return {
          ...state,
          formPhongMach: INITIAL_STATE.formPhongMach
        };
      } else if (action.payload.clinicType === CLINIC_TYPES.PK) {
        return {
          ...state,
          formPhongKham: INITIAL_STATE.formPhongKham
        };
      }
      return {
        ...state,
        ...INITIAL_STATE
      };
    }
    case TYPES.CLINIC_FORM_SUCCESS:
      return {
        ...state,
        ...INITIAL_STATE,
        successMessage: action.message
      };
    default:
      return state;
  }
};

const clinicReducerPersisted = persistReducer(
  {
    key: "clinic",
    storage: storage,
    blacklist: ["successMessage"]
  },
  clinicReducer
);

export default clinicReducerPersisted;
